export const ATTENTION_HISTORY_DOWNLOAD_HEADERS = {
  PROVIDER_USER: [[
    'ID_ATENCIÓN', 'ID_SERVICIO_MEDICO', 'ID_SEDE_PRESTADOR', 'ID_AFILIADO',
    'MODALIDAD', 'MONTO_NETO', 'OBSERVACIONES', 'FECHA_DE_CREACIÓN',
    'NOMBRE_SERVICIO', 'PROTOCOLO', 'NOMBRE_COMPLETO_AFILIADO',
    'DOCUMENTO_AFILIADO', 'NÚMERO_AFILIADO', 'NOMBRE_SERVICIO_MEDICO',
    'DESCRIPCIÓN_PRESTACIÓN', 'CODIGO_PRESTACIÓN', 'NOMBRE_PLAN',
    'MONTO_PAGADO', 'COPAGO', 'NOMBRE_SEDE', 'NOMBRE_PRESTADOR',
    'CREDENCIALES', 'CREADA_POR', 'FORMA_DE_PAGO', 'TIPO_DE_FORMA_DE_PAGO',
    'NÚMERO_FACTURA',
  ]],
  PROVIDER_ADMIN: [[
    'ID_ATENCIÓN', 'ID_SERVICIO_MEDICO', 'ID_SEDE', 'ID_AFILIADO',
    'MODALIDAD', 'MONTO_NETO', 'OBSERVACIONES', 'FECHA_DE_CREACIÓN',
    'NOMBRE', 'PROTOCOLO', 'NOMBRE_COMPLETO_AFILIADO', 'DOCUMENTO_AFILIADO',
    'NÚMERO_AFILIADO', 'NOMBRE_SERVICIO_MEDICO', 'CODIGO_PRESTACIÓN',
    'NOMBRE_SEDE', 'NOMBRE_PRESTADOR', 'MONTO_PAGADO', 'COPAGO',
    'NOMBRE_PLAN', 'DESCRIPCIÓN_PRESTACIÓN', 'CREDENCIALES', 'CREADA_POR',
    'FORMA_DE_PAGO', 'TIPO_DE_FORMA_DE_PAGO', 'NÚMERO_FACTURA',
  ]],
  ADMIN: [[
    'ID_ATENCIÓN', 'ID_SERVICIO_MEDICO', 'ID_SEDE_PRESTADOR', 'ID_AFILIADO',
    'MODALIDAD', 'MONTO_NETO', 'OBSERVACIONES', 'FECHA_CREACIÓN',
    'NOMBRE', 'PROTOCOLO', 'NOMBRE_SERVICIO_MEDICO', 'CODIGO_PRESTACIÓN',
    'NOMBRE_SEDE', 'NOMBRE_PRESTADOR', 'NOMBRE_PLAN',
    'DESCRIPCIÓN_PRESTACIÓN', 'NOMBRE_AFILIADO', 'MONTO_PAGADO', 'COPAGO',
    'DOCUMENTO_AFILIADO', 'NÚMERO_AFILIADO', 'CREADA_POR', 'FORMA_DE_PAGO',
    'TIPO_DE_FORMA_DE_PAGO', 'NÚMERO_FACTURA',
  ]],
};
